import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationAddressesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationAddress = (data): any => action(types.CREATE_ORGANISATION_ADDRESS_REQUESTED, data);

export const updateOrganisationAddress = (data): any => action(types.UPDATE_ORGANISATION_ADDRESS_REQUESTED, data);

export const deleteOrganisationAddress = (organisationAddressId): any => action(types.UPDATE_ORGANISATION_ADDRESS_REQUESTED, organisationAddressId);

export const getOrganisationAddress = (organisationAddressId): any => action(types.GET_ORGANISATION_ADDRESS_REQUESTED, organisationAddressId);

export const getAllOrganisationAddresses = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_ADDRESSES_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationAddress = (organisationAddressId): any => action(types.SELECT_ORGANISATION_ADDRESS_REQUESTED, {
  currentOrganisationAddressId: organisationAddressId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationAddressPending: (payload): any => action(types.CREATE_ORGANISATION_ADDRESS_PENDING, payload),
  createOrganisationAddressSuccess: (response): any => {
    const currentOrganisationAddress = response.entities.organisationAddresses[response.result];
    // history.push(`/payment/${currentOrganisationAddress.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_ADDRESS_SUCCESS, {
      organisationAddressesById: response.entities.organisationAddresses,
      currentOrganisationAddressId: response.result,
    });
  },
  updateOrganisationAddressPending: (payload): any => action(types.UPDATE_ORGANISATION_ADDRESS_PENDING, payload),
  updateOrganisationAddressSuccess: (response): any => action(types.UPDATE_ORGANISATION_ADDRESS_SUCCESS, {
    organisationAddressesById: response.entities.organisationAddresses,
    currentOrganisationAddressId: response.result,
  }),
  updateOrganisationAddressFailed: (error): any => action(types.UPDATE_ORGANISATION_ADDRESS_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationAddressPending: (): any => action(types.UPDATE_ORGANISATION_ADDRESS_PENDING, {}),
  deleteOrganisationAddressSuccess: (response, userId): any =>
  // localStorage.set(userId, { currentOrganisationAddressId: null });
  // history.push('/organisationAddresses');

    action(types.DELETE_ORGANISATION_ADDRESS_SUCCESS, {
      currentOrganisationAddressId: response,
    }),
  getOrganisationAddressPending: (): any => action(types.GET_ORGANISATION_ADDRESS_PENDING, {}),
  getOrganisationAddressSuccess: (response): any => action(types.GET_ORGANISATION_ADDRESS_SUCCESS, {
    organisationAddressesById: response.entities.organisationAddresses,
    currentOrganisationAddressId: response.result,
  }),
  getOrganisationAddressFailed: (error): any => action(types.GET_ORGANISATION_ADDRESS_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationAddressFailed: (error): any => action(types.UPDATE_ORGANISATION_ADDRESS_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationAddressesPending: (pagination): any => action(types.GET_ALL_ORGANISATION_ADDRESSES_PENDING, { pagination }),
  getAllOrganisationAddressesSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_ADDRESSES_SUCCESS, {
    organisationAddressesById: response.entities.organisationAddresses,
    organisationAddressIds: response.result,
    meta,
  }),
  getAllOrganisationAddressesFailed: (error): any => action(types.GET_ALL_ORGANISATION_ADDRESSES_FAIL, {
    backendErrors: error,
  }),
  createOrganisationAddressFailed: (error): any => action(types.CREATE_ORGANISATION_ADDRESS_FAIL, {
    backendErrors: error,
  }),
};

export default null;
